const Ndata = [
    {
      cover: "https://648e99873722947deac636f5--sage-dusk-64ff08.netlify.app/images/arrivals/arrivals1.png",
      name: "Sunglass",
      price: "150",
    },
    {
      cover: "https://648e99873722947deac636f5--sage-dusk-64ff08.netlify.app/images/arrivals/arrivals2.png",
      name: "Makeup",
      price: "250",
    },
    {
      cover: "https://648e99873722947deac636f5--sage-dusk-64ff08.netlify.app/images/arrivals/arrivals5.png",
      name: "Smart Watch",
      price: "50",
    },
    {
      cover: "https://648e99873722947deac636f5--sage-dusk-64ff08.netlify.app/images/arrivals/arrivals4.png",
      name: "Lipstick",
      price: "15",
    },
    {
      cover: "https://648e99873722947deac636f5--sage-dusk-64ff08.netlify.app/images/arrivals/arrivals5.png",
      name: "Green Plant",
      price: "10",
    },
    {
      cover: "https://648e99873722947deac636f5--sage-dusk-64ff08.netlify.app/images/arrivals/arrivals6.png",
      name: "Bonsai tree",
      price: "400",
    },
  ]
  
  export default Ndata